import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IUpdateUserSettingsRequest, IUserSettings } from '../models/user-settings';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {

  constructor(private http: HttpClient) { }

  getCurrentUserSettings() {
    return this.http.get<IUserSettings>(
      `${environment.baseUrl}/v1/UserSettings/getCurrentUserSettings`
    );
  }

  updateCurrentUserSettings(request: IUpdateUserSettingsRequest) {
    return this.http.put<string>(
      `${environment.baseUrl}/v1/UserSettings/updateCurrentUserSettings`,
      request
    );
  }
}
